/* eslint-disable max-len */
/* eslint-disable global-require */

/**
 * @description: 传入部分参数，返回分享组件所需 props 传值数据
 * @example
 *    import shareDataControl from '../../../common/js/ShareDataCreate';
 *
 *    初始化（有接口请求，建议放在 created 或 mounted ）
 *    this.shareControl = new shareDataControl(this.tid);
 *
 *    点击分享
 *    this.shareConfig = this.shareDataControl.createIndexConfig({
 *      param1: '111',
 *      param2: '222',
 *    });
 */

 import { util } from '@ali/amap-lib';
 import service from './service';
 import toast from './modules/toast';
 import CONFIG_ACT from '../../config/config.act';
 import CONFIG_URL from '../../config/config.url';
 
 export default class ShareDataCreate {
   constructor(params) {
     this.tid = params.tid;
     this.friendConfig = [{ tid: this.tid, sign: 1 }, { more: 1 }];
     this.shareData = {};
     this.initData();
   }
 
   /**
    * @description: 初始化数据，提前获取分享数据，加快分享图片生成
    * @return {*}
    */
   async initData() {
     const result = await service
       .shareConf(this.tid, 'gas_invite_inside')
       .catch(() => false);
     if (!result) return false;
     this.shareData = result;
     console.log('从接口提前获取分享数据，便于图片尽早生成(包含生成的图片URL、各种文案):', this.shareData)
   }
 
   /**
    * @description: 检查分享数据是否存在
    * @param {String} type 对应分享配置平台里面具体某处分享的 key 值
    * @returns {Boolean}
    */
   checkShareData(type) {
     if (
       this.shareData instanceof Object &&
       this.shareData[type] &&
       this.shareData[type].weixin
     ) {
       return true;
     } else {
       toast('网络开小差啦');
       return false;
     }
   }
 
   /**
    * @description: 将活动页面转为schema
    * @param {*} config
    * @return {*}
    */
   transformSchema(config) {
     const commonParams = {
       gd_from: 'share',
     }
     console.log('CONFIG_URL', CONFIG_URL, commonParams)
     const sourceUrl = util.urlAddParam(CONFIG_URL.endPage, commonParams);
     const otherParams = '&hide_title=1&sourceApplication=gas_invite_outside&urlType=0&contentType=autonavi';
     return `amapuri://webview/amaponline?url=${encodeURIComponent(sourceUrl)}${otherParams}`
   }
 
   /**
    * @description: 首页分享
    * @param {Object} params { shareToken: '' } 可扩展传入其他参数
    * @return {Object}
    */
   createIndexConfig(params = {}) {
    // 获取分享类型
    //  const { config,  actID } = params
     const { token, inviteChannel }=params
     console.log('sharedata-index-params\n', JSON.parse(JSON.stringify(params)));
     
     // 检查数据是否正常
     const dataIsOk = this.checkShareData(params.type);
     if (!dataIsOk) return false;
     
     // 分享主数据
     const config = this.shareData[params.type] || {};
     
     // canvas 预览图
    //  const previewImage = require('assets/share/close.png');

    // canvas 预览图
    // const previewImage = [
    //   {
    //     spellType: 1,
    //     url: shareImageBg,
    //     param: [0, 0, 750, 1334]
    //   }
    // ]; 
     
     // canvas 分享图
     const shareImage = [
       {
         spellType: 1,
         url: config.weixin.imgUrl||'',
         param: [0, 0, 750, 1334]
       }
     ];
     
     // 二维码样式
     const QRCodeConfig = {
       width: 214,
       height: 214,
       errorCorrectionLevel: 'Q',
       type: 'image/png',
       margin: 0,
       color: {
         dark: '#7B3117',
         light: '#0000' // 透明背景色
       }
     };
     
     // 二维码位置
     const QRCodePosition = [417, 920, 186, 186];
     
     const schema = this.transformSchema(params);
     const urlParams = {
       schema,
       local: 1,
       // id影响分享落地页的呼气页面
       id: 'gas_invite_outside',
     };

     const defaultURL = util.urlAddParam(CONFIG_URL.endPage, { 
        token,
        act_id: CONFIG_ACT.actId,
        inviteChannel
     });


      // url拼接参数
      // console.log('拼接URL参数 urlParams',urlParams)
     
     // 返回分享配置(根据微信和朋友圈是否配置图片分享，返回不同配置)
     const { shareType: weixinType } = config.weixin;
     const { shareType: pengyouType } = config.pengyou;
     const isShareImg = +weixinType === 1 || +pengyouType === 1;

      // 返回 CommonShare.vue 组件最终接收的传入数据
      const resData = {
        config,
        // previewImage: isShareImg ? previewImage : '',  // 预览图
        shareImage: isShareImg ? shareImage : [],
        QRCodeConfig: isShareImg ? QRCodeConfig : {},
        QRCodePosition: isShareImg ? QRCodePosition : [],
        defaultURL,
        urlParams
      };
      console.log('sharedata-index-return\n', JSON.parse(JSON.stringify(resData)));
      return resData;
   }
   // 其他分享，可参照首页分享方法 createIndexConfig 格式生成
 }
 
 
 /**
  * 拼图参数示例 --- 勿删
   const shareImage = [
     {
       spellType: 1, // 1=方形图片
       url: '',
       param: [0, 0, 750, 1334], // (x, y, width, height)
       // param: [sx, sy, swidth, sheight, x, y, width, height], // 图片裁剪并在画布上定位被裁剪的部分
     },
     {
       spellType: 2, // 2=圆形图片，如用户头像
       url: '', // 头像
       param: [285, 555, 180, 180],
       roundParam: [374, 648, 90, 0, 2 * Math.PI, false], //（圆心x、圆心y、圆半径、启始角、结束角、false顺时针true逆时针）
     },
     {
       spellType: 3, // 3=文字
       textParam: {
         words: '哈哈哈哈哈',
         top: 845,
         left: 372,
         textAlign: 'center',
         color: '#005a66',
         font: '46px bold',
         maxWidth: 350,
         lineHeight: 52
       }
     },
   ];
 */